module.exports = __webpack_public_path__ + "static/media/balduccis.ebcff947.svg";